import { Injectable } from '@angular/core';
import { BaseApiService } from './base-api.service';
import { SchedulerLoginUser } from '../../types/scheduler/scheduler-login-user.type';
import { SchedulerLoginUserGroup } from '../../types/scheduler/scheduler-login-user-group.type';
import { BaseModel } from '../../types/generated.types';
import { DateHelper } from '../../helpers/date.helper';
import { ApiConversionHelper } from '../../helpers/api-conversion.helper';

@Injectable({ providedIn: 'root' })
export class SchedulerLoginUsersApiService extends BaseApiService {
  protected get baseUrl(): string {
    return `${super.baseUrl}/scheduler-login-users`;
  }

  async getLoginUsers(tenantId?: string): Promise<SchedulerLoginUser[]> {
    const result = await this.get<SchedulerLoginUser[]>(tenantId ?? '');
    result.forEach(s => ApiConversionHelper.convertSchedulerLoginUser(s));
    return result;
  }

  async getLoginUserList(tenantId?: string): Promise<BaseModel[]> {
    return await this.get<BaseModel[]>(`list${this.getTenantParameter(tenantId)}`);
  }

  async createLoginUser(user: SchedulerLoginUser): Promise<string> {
    return await this.postWithResult('', user);
  }

  async updateLoginUser(user: SchedulerLoginUser): Promise<void> {
    return await this.put('', user);
  }

  async assignLoginUserToGroups(id: string, groupIds: string[]): Promise<void> {
    return await this.patch(`${id}/groups`, groupIds);
  }

  async deleteLoginUser(id: string): Promise<void> {
    return await this.delete(id);
  }

  async setLoginUserIsQuarantined(loginUserId: string, isQuarantined: boolean, endOfQuarantine?: Date): Promise<void> {
    return await this.patch(`${loginUserId}/is-quarantined`, { isQuarantined, endOfQuarantine: endOfQuarantine ? DateHelper.formatApiDateTime(endOfQuarantine) : undefined });
  }

  async getLoginUserGroups(tenantId?: string): Promise<SchedulerLoginUserGroup[]> {
    return await this.get<SchedulerLoginUserGroup[]>(`groups${this.getTenantParameter(tenantId)}`);
  }

  async getLoginUserGroupList(tenantId?: string): Promise<BaseModel[]> {
    return await this.get<BaseModel[]>(`groups/list${this.getTenantParameter(tenantId)}`);
  }

  async createLoginUserGroup(group: SchedulerLoginUserGroup): Promise<string> {
    return await this.postWithResult('groups', group);
  }

  async updateLoginUserGroup(group: SchedulerLoginUserGroup): Promise<void> {
    return await this.put(`groups`, group);
  }

  async deleteLoginUserGroup(id: string): Promise<void> {
    return await this.delete(`groups/${id}`);
  }
}
